import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@material-ui/core';
import { StockMovementStatus } from 'types/models/StockMovement';

const MOVEMENT_STATUS_LABEL: Record<StockMovementStatus, string> = {
  [StockMovementStatus.DRAFT]: 'status.draft',
  [StockMovementStatus.CONFIRMED]: 'status.confirmed',
  [StockMovementStatus.CANCELLED]: 'status.cancelled',
};

const MOVEMENT_STATUS_COLOR: Record<StockMovementStatus, 'default' | 'primary' | 'secondary'> = {
  [StockMovementStatus.DRAFT]: 'secondary',
  [StockMovementStatus.CONFIRMED]: 'primary',
  [StockMovementStatus.CANCELLED]: 'default',
};

interface Props {
  status?: StockMovementStatus;
}

const MovementStatusChip: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation();

  if (!status) return <>—</>;

  return (
    <Chip
      size="small"
      variant="outlined"
      color={MOVEMENT_STATUS_COLOR[status]}
      label={t(MOVEMENT_STATUS_LABEL[status])}
    />
  );
};

export default MovementStatusChip;
